export default "__VITE_ASSET__bh2V49ET__"